define('views/root/join',[
    'backbone',
    'views/_base/baseview',
    'text!views/root/join.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        tagName  : 'div',
        className: 'join-inner-container',
        template : _.template(Template),
        isRender : true,
        needsAuth: false,
        events   : {
            'click .js-join-for-free': 'goToRegistration'
        },

        initialize: function(options){
            options = options || {};

            this.elementName = options.elementName;
            
            BaseView.prototype.initialize(this, options);
        },
        
        render: function(){

            this.$el.html(this.template());

            return this;
        },

        goToRegistration: function(e){

            if(pf.fb_pixel){
                pf.fb_pixel.checkout();
            }

            pf.navigate($(e.target).attr('href'));

            return false;
        },

        close: function(){}

    });
});
